<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <strong>{{ caption }}</strong> 分组
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="分组名" label-for="name">
          <b-form-input id="name" type="text" v-model="data.name"
              required></b-form-input>
        </b-form-group>
        <b-form-group label="标签" label-for="tag">
          <b-form-checkbox-group name="tag" v-model="data.tags" :options="tagList"
                                 buttons button-variant="outline-secondary">
          </b-form-checkbox-group>
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check"></i> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-danger"><i class="fa fa-remove"></i> 返回</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'

export default {
  name: 'group-update',
  mixins: [Error],
  data () {
    return {
      data: {
        name: '',
        tags: []
      },
      tagList: []
    }
  },
  computed: {
    // eslint-disable-next-line
    isUpdate: function () { return this.$route.params.groupId ? true : false },
    caption: function () { return this.isUpdate ? '更新' : '创建' }
  },
  created () {
    this.$ajax.get(api.getTagList()).then((tagRes) => {
      tagRes.tags.forEach((tag) => {
        this.tagList.push({
          value: tag['tag'], text: tag['name']
        })
      })
    }, (res) => {
      this.handleError(res[0])
    })
    if (this.isUpdate) {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.$ajax.get(
        api.getGroupDetail(this.$route.params.groupId)
      ).then((res) => {
        this.data.tags = res.group.tags ? res.group.tags : []
        this.data.name = res.group.name
      }, (res) => {
        this.handleError(res)
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      if (this.isUpdate) {
        api.updateData(this, api.getGroupDetail(this.$route.params.groupId), this.data)
      } else {
        api.createData(this, api.getGroupCreate(), this.data, 'group-list')
      }
    },
    onReset (evt) {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupCreate.vue?76e5bf1c